(function () {
  const HIDDEN_CLASS = 'is-variant-hidden';

  function getSelectedColor(root) {
    const scope = root || document;
    const activeSwatch = scope.querySelector('.options-color-wrapper.active .option-item[data-value]');
    if (activeSwatch) {
      return (activeSwatch.getAttribute('data-value') || '').trim();
    }

    const checkedInput = scope.querySelector(
      '.single-option-radio input:checked, variant-selects fieldset input:checked'
    );
    if (checkedInput) {
      return (checkedInput.value || '').trim();
    }

    return '';
  }

  function parseMatchRules(matchValue) {
    return matchValue
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);
  }

  function colorMatchesRules(selectedColor, rules) {
    if (!rules.length) {
      return true;
    }
    if (!selectedColor) {
      return false;
    }
    return rules.some((rule) => rule === selectedColor);
  }

  function updateBenefitVisibility(root) {
    const scope = root || document.querySelector('.product_template_new');
    if (!scope) {
      return;
    }

    const selectedColor = getSelectedColor(scope);

    scope.querySelectorAll('.benefit-wrapper.buy-x-get-y').forEach((element) => {
      const matchValue = (element.dataset.variantMatch || '').trim();
      if (!matchValue) {
        element.classList.remove(HIDDEN_CLASS);
        return;
      }

      const rules = parseMatchRules(matchValue);
      const visible = colorMatchesRules(selectedColor, rules);
      element.classList.toggle(HIDDEN_CLASS, !visible);
    });
  }

  function initBenefitVariantVisibility() {
    const root = document.querySelector('.product_template_new');
    if (!root) {
      return;
    }
    if (!root.querySelector('.benefit-wrapper.buy-x-get-y[data-variant-match]')) {
      return;
    }

    updateBenefitVisibility(root);

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      if (
        target.closest('.options-color-wrapper') ||
        target.closest('.single-option-radio label') ||
        target.closest('.toggle-product-size-item')
      ) {
        window.requestAnimationFrame(() => updateBenefitVisibility(root));
      }
    });

    const variantContainer =
      root.querySelector('.product-single__add-to-cart') ||
      root.querySelector('.variant-selects-wrapper') ||
      root.querySelector('.product-form__item');

    if (variantContainer) {
      const observer = new MutationObserver(() => updateBenefitVisibility(root));
      observer.observe(variantContainer, {
        childList: true,
        subtree: true,
        attributes: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitVariantVisibility);
  } else {
    initBenefitVariantVisibility();
  }

  window.updateBenefitVisibility = updateBenefitVisibility;
})();
